import type { TLocalize } from '@hooks/use-localize';
import { useDonorConnect } from '@/hooks/register/use-donor-connect';
import { useSession } from '@hooks/security/use-session';
import { useRefreshShell, useShell } from '@/context/shell-context';

interface IProps {
    t: TLocalize;
    isLiver?: boolean;
}

const MENTOR_VIDEO_URL =
    'https://player.vimeo.com/video/1143834262?h=c2c754eea1&badge=0&autopause=0&player_id=0&app_id=58479';

const MentorOfferSection = ({ t, isLiver }: IProps) => {
    const { registrationId, editKey } = useSession();
    const { submit, isSubmitting, submitError } = useDonorConnect(registrationId, editKey);
    const { connectToDonorStatus } = useShell();
    const refreshShell = useRefreshShell();

    const handleConnect = async (connect: boolean) => {
        const result = await submit(connect);

        if (result.ok) {
            refreshShell();
        }
    };

    return (
        <div className="mentor-card">
            <div className="mentor-card-body">
                <h4 className="mentor-card-title">
                    {t('DashLabel_DonorMentorTitle', 'A Donor Mentor is Here for You Throughout Your Donation Journey')}
                </h4>

                <div className="mentor-video">
                    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                        <iframe
                            src={MENTOR_VIDEO_URL}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            title="Donor Mentors"
                        ></iframe>
                    </div>
                </div>

                {connectToDonorStatus != null ?
                    <>
                        <h4 className="mentor-text">
                            {t(
                                'DashLabel_ThankYou',
                                'Thank You',
                            )}
                        </h4>

                        <h5 className="mentor-text">
                            {t(
                                'DashLabel_WeHaveReceivedYourRequestConnect ',
                                'We have received your request for a donor mentor; we will work to connect you with a donor mentor as soon as possible.',
                            )}
                        </h5>
                    </>
                    :
                    <>
                        <p className="mentor-text">
                            {t('DashLabel_DonorMentorDescription', 'If you would like to discuss these options with someone who has been through the donation process, opt in to the donor mentor program. You will be connected with a living donor who can share their experience and help you decide which option is best for you. This service is completely free and optional.')}
                        </p>

                        <div className="form-group mentor-question">
                            <label className="control-label">
                                *
                                {isLiver
                                    ? t('DashLabel_DonorConnectOptInQuestionLiver', 'Would you like to connect with someone who has donated part of their liver? Select yes below to connect with a donor mentor who can help guide you through your donation journey.')
                                    : t('DashLabel_DonorConnectOptInQuestion', 'Would you like us to connect you with a living donor mentor who can answer your questions and help you better understand the process?')}
                            </label>

                            <div className='mentor-buttons'>
                                <button type="button" className='btn btn-primary' disabled={isSubmitting} onClick={() => handleConnect(true)}>{t('Word_Yes', 'Yes')}</button>
                                <button type="button" className='btn btn-secondary' disabled={isSubmitting} onClick={() => handleConnect(false)}>{t('Label_NotAtThisTime', 'Not at this time')}</button>
                            </div>

                            {submitError && <div className="alert alert-danger">{submitError}</div>}
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default MentorOfferSection;

